import { useMutation } from "convex/react";
import { api } from "convex/_generated/api";
import { useAuth } from "@clerk/tanstack-react-start";
import { feedbackFormOpts, feedbackSchema } from "../types/feedbackSchema";
import type { FormEvent } from "react";
import { useAppForm } from "@/components/forms/hooks/form";
import { useFormStatus } from "@/components/forms/hooks/useFormStatus";

export const useFeedbackForm = () => {
  const { userId } = useAuth();
  const {
    errorMessage,
    successMessage,
    isSubmitting,
    setError,
    setSuccess,
    setSubmitting,
    resetStatus,
  } = useFormStatus();
  const createFeedbackMutation = useMutation(api.feedback.createFeedback);

  const form = useAppForm({
    ...feedbackFormOpts,
    defaultValues: {
      email: "",
      message: "",
    },
    validators: {
      onChange: feedbackSchema,
    },
    onSubmit: async ({
      value,
    }: {
      value: { email: string; message: string };
    }) => {
      resetStatus();
      setSubmitting(true);
      try {
        await createFeedbackMutation({
          email: value.email,
          message: value.message,
          user_id: userId ?? undefined,
        });
        setSuccess("Thank you for your feedback!");
        form.reset();
      } catch {
        setError("Failed to submit feedback. Please try again.");
      } finally {
        setSubmitting(false);
      }
    },
  });

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    form.handleSubmit();
  };

  return { form, handleSubmit, errorMessage, successMessage, isSubmitting };
};
